import React, { Component, Fragment } from "react";
import AdvisorContext from "../../context/context";
import ReactTable from "react-table";
import moment from "moment-timezone";
import enumHelper from "../../../support/logic/enumHelper";
import { eventType } from "../../enums.js";
import EditIcon from '@mui/icons-material/Edit';
import { Tabs, Tab } from '@mui/material';
import { Grid, Button, Typography } from '@material-ui/core';


const activityTypes = enumHelper.getSelectOptionsList(eventType)

function firstDefined(obj, ...keys) {
    for (const k of keys) {
        const v = obj?.[k];
        if (v !== undefined && v !== null) return v;
    }
    return null;
}
function fmtWhen(m) {
    const iso = pickWhenRaw(m);
    return iso ? moment(iso).format("M/D/YY h:mm a") : "—";
}
function pickWhenRaw(m) {
    // tolerate snake/camel from the server
    return (
        firstDefined(m, "created", "created") ||
        firstDefined(m, "sentAt", "sent_at") ||
        firstDefined(m, "receivedAt", "received_at") ||

        null
    );
}
class ActivitiesList extends Component {
    static contextType = AdvisorContext;

    constructor(props) {
        super(props);

        this.state = {
            actVis: "tabVisible",
            msgVis: "tabHidden",
            chtVis: "tabHidden",
            tab: 0


        };
    }

displayDate = (val) => {
        if (!val) return "";

        
        return moment.utc(
            val.endsWith("Z") ? val : `${val}Z` 
        )
            .tz("America/New_York")
            .format("M/D/YY h:mm a");
    };

    componentDidMount() {
        
    }
    componentDidUpdate(prevProps, prevState) {
        


    }

    setTab = (event, newVal) => {
        let actVis = "tabHidden";
        let msgVis = "tabHidden";
        let chtVis: "tabHidden";

        switch (newVal) {
            case 0:

                actVis = "tabVisible";

                break;
            case 1:
                msgVis = "tabVisible";
                break;
            case 2:
                chtVis = "tabVisible";
                break;
            default:

                break;


        }

        this.setState({ tab: newVal, actVis: actVis, msgVis: msgVis, chtVis: chtVis });
    }

    render() {
        //console.log(this);
        let columns = [

            {
                Header: "",
                accessor: "id",
                width: 50,
                Cell: row => (
                    <div className="dataCell" style={{
                        textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }} ><EditIcon onClick={() => this.props.openEntry(row.original) } /></div>
                ),

            }, {
                Header: "Title",
                accessor: "title",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }} >{row.original.title}</div>
                ),

            },
            {
                Header: "Description",
                accessor: "description",
                width: 300,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }} >{row.original.description}</div>
                ),

            },
            {
                Header: "Credit Hours",
                accessor: "totalAvailableCreditHours",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }} >{row.original.totalAvailableCreditHours}</div>
                ),

            },
            {
                Header: "Start Date/Time",
                accessor: "startTime",
                width: 100,
                Cell: (row) => {
                    const lCont = row.value !== null ? moment(row.value).format("M/D/YY h:mm a") : "";
                    return <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }}>{lCont}</div>;
                },

            }
            ,
            {
                Header: "End Date/Time",
                accessor: "endTime",
                width: 100,
                Cell: (row) => {
                    const lCont = row.value !== null ? moment(row.value).format("M/D/YY h:mm a") : "";
                    return <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }}>{lCont}</div>;
                },

            }
            ,
            {
                Header: "Activity Type",
                accessor: "type",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }} >{enumHelper.getDisplayName(eventType, row.original.type) }</div>
                ),

            }
            ,
            {
                Header: "Grade",
                accessor: "grade",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }} >{row.original.grade}</div>
                ),

            },
            {
                Header: "School/Institution",
                accessor: "schoolOrInst",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }} >{row.original.schoolOrInst}</div>
                ),

            },

            {
                Header: "Created By",
                accessor: "creator",
                width: 300,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center", color: row.original.tagHours === false ? 'red' : undefined }} >{row.original.creator}</div>
                ),

            }


        ];

        const chColumns = [

           
            {
                Header: "When",
                id: "created",
                accessor: (m) => m.created ?? m.createdAt ?? m.sentAt ?? m.receivedAt ?? "",
                Cell: ({ original }) => <div style={{ textAlign: "center" }}>{fmtWhen(original)}</div>,
                width: 160,
                filterMethod: (filter, row) =>
                    (row[filter.id] || "").toLowerCase().includes((filter.value || "").toLowerCase()),
            },
            {
                Header: "Direction",
                id: "direction",
                accessor: (m) => (m.direction || "").toLowerCase(),
                width: 110,
                Cell: ({ value }) => (
                    <div style={{ textAlign: "center", fontWeight: 600 }}>
                        {value === "incoming" ? "← Incoming" : value === "outgoing" ? "→ Outgoing" : "—"}
                    </div>
                ),
                filterMethod: (filter, row) =>
                    (row[filter.id] || "").includes((filter.value || "").toLowerCase()),
            },
            {
                Header: "Body",
                id: "body",
                accessor: (m) => m.body ?? m.text ?? "",
                Cell: ({ value }) => <div style={{ whiteSpace: "pre-wrap" }}>{value || "—"}</div>,
                minWidth: 300,
                filterMethod: (filter, row) =>
                    (row[filter.id] || "").toLowerCase().includes((filter.value || "").toLowerCase()),
            },

            {
                Header: "Source",
                id: "outgoingSource",
                accessor: (m) => m.outgoingSource || "User",
                width: 140,
                Cell: ({ value }) => <div style={{ textAlign: "center" }}>{value || "—"}</div>,
                filterMethod: (filter, row) =>
                    (row[filter.id] || "").toLowerCase().includes((filter.value || "").toLowerCase()),
            },
            {
                Header: "Topic",
                id: "understandingTopic",
                accessor: (m) => m.understandingTopic || "",
                width: 200,
                Cell: ({ value }) => <div style={{ textAlign: "center" }}>{value || "—"}</div>,
                filterMethod: (filter, row) =>
                    (row[filter.id] || "").toLowerCase().includes((filter.value || "").toLowerCase()),
            },
        ];

        let messageColumns = [

            {
                Header: "",
                accessor: "id",
                width: 50,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} ><EditIcon onClick={() => this.props.openMessageEntry(row.original)} /></div>
                ),

            },
            {
                Header: "Sender",
                accessor: "sender",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.sender}</div>
                ),

            },
            {
                Header: "Sent Date",
                accessor: "sentTime",
                width: 100,
                Cell: (row) => {
                    return <div className="dataCell" style={{ textAlign: "center" }}>{this.displayDate(row.value)}</div>;
                },

            }
            , {
                Header: "Subject",
                accessor: "subject",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.subject}</div>
                ),

            },
            {
                Header: "Email Body",
                accessor: "content",
                width: 300,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.content}</div>
                ),

            },
            {
                Header: "Text Body",
                accessor: "textBody",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.textBody}</div>
                ),

            },
            {
                Header: "Email Status",
                accessor: "emailStatus",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.emailStatus}</div>
                ),

            }
            ,
            {
                Header: "Text Status",
                accessor: "textStatus",
                width: 100,
                Cell: row => (
                    <div className="dataCell" style={{ textAlign: "center" }} >{row.original.textStatus}</div>
                ),

            }
            


        ];
        
        return <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
            <Tabs value={this.state.tab} onChange={this.setTab} aria-label="Activity Sections" variant="fullWidth"
                sx={{
                    '.MuiTabs-flexContainer': {
                        justifyContent: 'space-evenly',
                    },
                    '.MuiTab-root': {
                        border: '1px solid #000',
                        borderBottom: 'none',
                        borderTopLeftRadius: '10px',
                        borderTopRightRadius: '10px',
                        marginRight: '4px',
                        '&:last-child': {
                            marginRight: 0,
                        },
                        '&.Mui-selected': {
                            backgroundColor: '#123225',
                            color: '#fff',
                        },
                        '&:hover': {
                            backgroundColor: '#123225',
                            color: '#fff',
                            opacity: 1,
                        },
                    },
                }}
            >
                        <Tab label="Activities" />
                
                        <Tab label="Messages" />
                        <Tab label="Chats" />
                    </Tabs>
                </Grid>
                <Grid container spacing={2} className={this.state.actVis}>
                    <Grid item xs={12}>
            <ReactTable
                data={this.props.data}
                minRows={0}
                columns={columns}
                defaultPageSize={50}
                className="-striped -highlight tableWrapper"
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={this.state.msgVis}>
                    <Grid item xs={12}>
                        <ReactTable
                            data={this.props.message}
                            minRows={0}
                            columns={messageColumns}
                            defaultPageSize={50}
                            className="-striped -highlight tableWrapper"
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} className={this.state.chtVis}>
                    <Grid item xs={12}>
                        <ReactTable
                            data={this.props.chat}
                            minRows={0}
                            columns={chColumns}
                            defaultPageSize={50}
                            className="-striped -highlight tableWrapper"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </div>;
    }
}

export default ActivitiesList;